import { render, staticRenderFns } from "./capitalAccountDetail.vue?vue&type=template&id=16d8a6ee"
import script from "./capitalAccountDetail.vue?vue&type=script&lang=js"
export * from "./capitalAccountDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports